export default __webpack_public_path__ + "static/nav1-a020f2705dd875e863080c7d73a9710c.jpg";